import React, { useState } from "react";
import Headline from "./Headline";
import { Button, Flex, Form, Input, Modal, notification } from "antd";
import HomeLink from "../../widgets/HomeLink";
import UserApi from "../../api-services/user-api.service";
import { useNavigate } from "react-router-dom";


const validateMessages = {
  required: '${label} is required!'
};

type FieldType = {
  username?: string;
  password?: string;
};

const bannerPath = '/iceholidays-assets/images/partner_signin_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Partner Sign In' }
]

const PartnerSignInPage: React.FC = () => {
  const [signInForm] = Form.useForm();  
  const [forgotPasswordModalVisible, showForgotPasswordModal] = useState(false);
  const navigate = useNavigate();


  const showModal = () => {
    showForgotPasswordModal(true);
  }

  const closeModal = () => {
    showForgotPasswordModal(false);
  }

  const sendRequest = (formValues) => {
    UserApi.forgotPassword(formValues.username)
      .then(success => {
        if(success){
          closeModal();
          Modal.success({
            content: "If your username exists in our database, you will receive a password recovery link at your email address in a few minutes."
          });
        }
      })
      .catch(error => {
        notification.error({ message: error.response.data.error});
      });
  };

  const submitForm = (formValues) => {
    UserApi.login(formValues)
      .then(success => {
        if(success){
          localStorage.removeItem('currentUser');
          navigate('/web');
          navigate(0);
        }
      })
      .catch(error => {
        notification.error({ message: error.response.data.error});
      });
  }

  return (
    <div id="partner-sign-in" className="gd-series-tour-page signin-page">
      <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
        <span className="title">
          Partner Sign In
        </span>
      </Headline>

      <div className="gd-series-tour-page_body">
        <div className="signin-page-form">
          <Form
            form={signInForm}
            autoComplete="off"
            layout="vertical"
            variant="filled"
            onFinish={(formValues)=>submitForm(formValues)}
          >
            <label>Sign In</label>              
            <Form.Item<FieldType>
              label="Username"
              name="username"
              rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input placeholder="Enter Username"/>
            </Form.Item>

            <Form.Item<FieldType>
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password placeholder="Enter Password"/>
            </Form.Item>

            <p id="forgot-password" onClick={showModal}>forgot Password?</p>

            <Flex align="center" justify="center">
              <Button type="primary" htmlType="submit">
                Sign In
              </Button>
            </Flex>
          </Form>
          {/* <div id="download-options">
            <div>
              <h2>Download the App</h2>
              <p>Scan me now</p>
            </div>

            <img id="qr" src='/iceholidays-assets/images/download_qr.png'/>

            <small>or</small>

            <Space size={14} direction="vertical" align="center">
              <a target="_blank" href="https://apps.apple.com/my/app/golden-destinations/id1446862869"><img src="/iceholidays-assets/images/social/app_store_black.png"/></a>
              <a target="_blank" href="/"><img src="/iceholidays-assets/images/social/google_play_black.png"/></a>
            </Space>
          </div> */}
        </div>
      </div>

      <Modal title={
        <>
          <h2>Forgot Password</h2>
          <p>To reset your password, please enter vour username</p>
        </>
      } open={forgotPasswordModalVisible} onCancel={closeModal} footer={null} width={800} centered className="forgot_password_modal">          
          <Form
            autoComplete="off"
            layout="vertical"
            variant="filled"
            validateMessages={validateMessages}
            onFinish={sendRequest}
            className="forgot-password-form"
          >
            <Form.Item label="Username" name="username" required>
              <Input placeholder="Enter Username" />
            </Form.Item>

            <Flex align="center" justify="center">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Flex>
          </Form>
      </Modal>

    </div>
  )
}

export default PartnerSignInPage;
